// extracted by mini-css-extract-plugin
module.exports = {"orderList":"orderList_orderList__1grb-"};